import type { SpatialFile } from '@/types';
import type { ObjectRendererProps } from './types';
import styles from '../ObjectView.module.css';

const formatBytes = (n: number): string => {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const FileRenderer = ({ object: file }: ObjectRendererProps<SpatialFile>) => (
  <div className={styles.tile}>
    <span className={styles.tileIcon} aria-hidden="true">
      ▢
    </span>
    <strong className={styles.tileTitle}>{file.fileName}</strong>
    <span className={styles.tileMeta}>
      {file.mimeType} · {formatBytes(file.byteSize)}
    </span>
  </div>
);
